import { arraysEqual } from '../../../utilities';
import { CHANNEL_MAPPING } from './channel_mapping_constants';

export function getChannelMappingFilters (channelMappings) {
  let cognosChannelTypeOptions = new Set();
  let cognosChannelOptions = new Set();
  let cognosParentChannelOptions = new Set();
  let hcpMerchantChannelOptions = new Set();
  let hcpChannelTypeOptions = new Set();
  let groupCodeOptions = new Set();
  let marketplaceIdOptions = new Set();
  let derivedMarketplaceIdOptions = new Set();
  let marketplaceNameOptions = new Set();
  if (channelMappings) {
    channelMappings.forEach(channelMapping => {
      if (channelMapping.cognosChannelType) {
        cognosChannelTypeOptions.add(channelMapping.cognosChannelType);
      }
      if (channelMapping.cognosChannel) {
        cognosChannelOptions.add(channelMapping.cognosChannel);
      }
      if (channelMapping.cognosParentChannel) {
        cognosParentChannelOptions.add(channelMapping.cognosParentChannel);
      }
      if (channelMapping.hcpMerchantChannel) {
        hcpMerchantChannelOptions.add(channelMapping.hcpMerchantChannel);
      }
      if (channelMapping.hcpChannelType) {
        hcpChannelTypeOptions.add(channelMapping.hcpChannelType);
      }
      if (channelMapping.groupCode) {
        groupCodeOptions.add(channelMapping.groupCode);
      }
      if (channelMapping.marketplaceId) {
        marketplaceIdOptions.add(channelMapping.marketplaceId);
      }
      if (channelMapping.derivedMarketplaceId) {
        derivedMarketplaceIdOptions.add(channelMapping.derivedMarketplaceId);
      }
      if (channelMapping.marketplaceName) {
        marketplaceNameOptions.add(channelMapping.marketplaceName);
      }
    });
  }
  return [
    {
      groupValuesLabel: 'Cognos Channel Type Values',
      propertyKey: 'cognosChannelType',
      propertyLabel: 'Cognos Channel Type',
      values: Array.from(cognosChannelTypeOptions),
    },
    {
      groupValuesLabel: 'Cognos Channel Values',
      propertyKey: 'cognosChannel',
      propertyLabel: 'Cognos Channel',
      values: Array.from(cognosChannelOptions),
    },
    {
      groupValuesLabel: 'Cognos Parent Channel Values',
      propertyKey: 'cognosParentChannel',
      propertyLabel: 'Cognos Parent Channel',
      values: Array.from(cognosParentChannelOptions),
    },
    {
      groupValuesLabel: 'HCP Merchant Channel Values',
      propertyKey: 'hcpMerchantChannel',
      propertyLabel: 'HCP Merchant Channel',
      values: Array.from(hcpMerchantChannelOptions),
    },
    {
      groupValuesLabel: 'HCP Channel Type Values',
      propertyKey: 'hcpChannelType',
      propertyLabel: 'HCP Channel Type',
      values: Array.from(hcpChannelTypeOptions),
    },
    {
      groupValuesLabel: 'Cognos Group Code Values',
      propertyKey: 'groupCode',
      propertyLabel: 'Cognos Group Code',
      values: Array.from(groupCodeOptions),
    },
    {
      groupValuesLabel: 'Marketplace Id Values',
      propertyKey: 'marketplaceId',
      propertyLabel: 'Marketplace Id',
      values: Array.from(marketplaceIdOptions),
    },
    {
      groupValuesLabel: 'Derived Marketplace Id Values',
      propertyKey: 'derivedMarketplaceId',
      propertyLabel: 'Derived Marketplace Id',
      values: Array.from(derivedMarketplaceIdOptions),
    },
    {
      groupValuesLabel: 'Marketplace Name Values',
      propertyKey: 'marketplaceName',
      propertyLabel: 'Marketplace Name',
      values: Array.from(marketplaceNameOptions),
    },
  ];
}

export const isChannelMappingModified = (
  originalChannelMapping,
  modifiedChannelMapping,
  fieldsToCheck = CHANNEL_MAPPING.EDITABLE_FIELDS
) => {
  // Checking a fixed no of fields isn't generic - but
  // more efficient than doing a deep comparison.
  for (let field of fieldsToCheck) {
    const originalValue = originalChannelMapping[field];
    const modifiedValue = modifiedChannelMapping[field];

    if (!areFieldValuesEquivalent(originalValue, modifiedValue)) {
      return true;
    }
  }

  return false;
};

export const areFieldValuesEquivalent = (value1, value2) => {
  if (!value1 && !value2) {
    return true;
  }

  if ((!value1 && value2) || (value1 && !value2)) {
    return false;
  }

  if (Array.isArray(value1) && Array.isArray(value2)) {
    return arraysEqual(value1, value2);
  }

  if (value1.hasOwnProperty('id') && value2.hasOwnProperty('id')) {
    return value1['id'] === value2['id'];
  }

  return value1 === value2;
};

export function getHCPChannelTypeOptions (channelMappings) {
  let hcpChannelTypeOptions = new Set();
  channelMappings.forEach(channelMapping => (hcpChannelTypeOptions.add(channelMapping.hcpChannelType)));
    return Array.from(hcpChannelTypeOptions).map((channelType) => {
      return {
        value: channelType,
        label: `${channelType}`,
      };
    });
}

export function getHCPChannelOptions (channelMappings) {
  let hcpChannelOptions = new Set();
  channelMappings.forEach(channelMapping => (hcpChannelOptions.add(channelMapping.hcpMerchantChannel)));
  return Array.from(hcpChannelOptions).map((channel) => {
    return {
      value: channel,
      label: `${channel}`,
    };
  });
}

export function getCognosChannelOptions (channelMappings) {
  let cognosChannelOptions = new Set();
  channelMappings.forEach(channelMapping => (cognosChannelOptions.add(channelMapping.cognosChannel)));
  return Array.from(cognosChannelOptions).map((cognosChannel) => {
    return {
      value: cognosChannel,
      label: `${cognosChannel}`,
    };
  });
}

export function getGroupCodeOptions (channelMappings) {
  let groupCodeOptions = new Set();
  channelMappings.forEach(channelMapping => (groupCodeOptions.add(channelMapping.groupCode)));
  return Array.from(groupCodeOptions).map((groupCode) => {
    return {
      value: groupCode,
      label: `${groupCode}`,
    };
  });
}

export function getCognosParentChannelOptions (channelMappings) {
  let cognosParentChannelOptions = new Set();
  channelMappings.forEach(channelMapping => (cognosParentChannelOptions.add(channelMapping.cognosParentChannel)));
  return Array.from(cognosParentChannelOptions).map((cognosParentChannel) => {
    return {
      value: cognosParentChannel,
      label: `${cognosParentChannel}`,
    };
  });
}


export function getMarketplaceIdOptions (marketplaceConfig) {
  let marketplaceIdOptions = new Set();
  marketplaceConfig.forEach(item => (item.derivedMarketplaceIds && item.derivedMarketplaceIds.forEach(marketplaceId => marketplaceIdOptions.add(marketplaceId))));
  return Array.from(marketplaceIdOptions).sort().map((id) => {
    return {
      value: id,
      label: `${id}`,
    };
  });
}



// WEBPACK FOOTER //
// ./src/components/config_central/channel_mapping/channel_mapping_utils.jsx